import { useCallback, type MouseEvent } from "react"
import { cn, assetUrl } from "@/lib/utils"
import { spawnEmojiFirework } from "@/lib/emoji-firework"

export const SAFECLAW_LOGO_SRC = assetUrl("/SafeClawLogo.webp")
export const SAFECLAW_LOGO_WIDTH = 1244
export const SAFECLAW_LOGO_HEIGHT = 350

type SafeClawLogoProps = {
  className?: string
  height?: number
  firework?: boolean
  onClick?: (e: MouseEvent<HTMLImageElement>) => void
}

export function SafeClawLogo({
  className,
  height = 40,
  firework = true,
  onClick,
}: SafeClawLogoProps) {
  const handleClick = useCallback((e: MouseEvent<HTMLImageElement>) => {
    onClick?.(e)
    if (!firework) return
    spawnEmojiFirework(e.clientX, e.clientY)
  }, [firework, onClick])

  const isClickable = firework || !!onClick

  return (
    <img
      src={SAFECLAW_LOGO_SRC}
      alt="SafeClaw"
      style={{ height }}
      className={cn(
        "w-auto max-w-full object-contain object-left shrink-0 outline-none",
        isClickable && "cursor-pointer",
        className,
      )}
      onClick={handleClick}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
    />
  )
}
